import React, { useState } from 'react';
import { useAppContext } from '@cherre-frontend/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from 'src/components/ButtonProgress';
import { default as styled } from '@mui/material/styles/styled';

const DialogStyled = styled(Dialog)`
  & .MuiPaper-root {
    width: 520px;
  }
  & .MuiDialogTitle-root {
    padding: 20px 20px 6px;
  }
  & .MuiDialogContent-root {
    padding: 0 20px 0;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  & .MuiDialogActions-root {
    padding: 20px;
  }
`;

interface OpenSubmissionsModalProps {
  open: boolean;
  onClose: () => void;
}

const OpenSubmissionsModal: React.FC<OpenSubmissionsModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <DialogStyled open={open} onClose={onClose}>
      <DialogTitle>Open Submissions</DialogTitle>
      <DialogContent>
        In order to migrate this organization from the legacy 1:1 DSP model to
        M:1, please instruct the DSP Admin to close all submission batches
        related to this organization.
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary' variant='contained'>
          Ok
        </Button>
      </DialogActions>
    </DialogStyled>
  );
};

const getOpenSubmissions = async (orgId: number) => {
  const endpoint = `/api/v1/dsp/organization/${orgId}/open_submissions`;
  const results = await fetch(endpoint, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return results.json();
};

const migrateOrganization = (orgId: number) => {
  const endpoint = `/api/v1/dsp/organization/${orgId}/migrate_to_m1`;
  return fetch(endpoint, { method: 'post' });
};

const MigrateToM1: React.FC<any> = (props) => {
  const { data, open, onRequestClose } = props;
  const [openSubmissionsModal, setOpenSubmissionsModal] = useState(false);
  const context = useAppContext();

  const continueMigration = async () => {
    // Fetch open submissions
    const result = await getOpenSubmissions(data.row.id);

    // Check if there are open submissions
    if (result.sys_submissions && result.sys_submissions.length > 0) {
      setOpenSubmissionsModal(true);
    } else {
      // Proceed with migration if no open submissions
      const migrationResponse = await migrateOrganization(data.row.id);

      if (migrationResponse.ok) {
        context.showSnackbar({
          message: 'Organization migrated to M:1',
          type: 'success',
        });
      } else {
        context.showSnackbar({
          message: 'Migration to M:1 failed',
          type: 'error',
        });
      }

      // Update the table state to hide Migate to M:1 option
      data.removeLegacyOrganization(data.row.id);

      // Close the modal
      onRequestClose();
      setOpenSubmissionsModal(false);
    }
  };

  return (
    <>
      <DialogStyled open={open} onClose={onRequestClose}>
        <DialogTitle>Are you sure you want to continue?</DialogTitle>
        <DialogContent>
          You are about to migrate this organization from the legacy 1:1 DSP
          model to M:1. Please note that this action cannot be reversed.
        </DialogContent>
        <DialogActions>
          <Button onClick={onRequestClose} color='primary'>
            Cancel
          </Button>
          <Button
            onClick={continueMigration}
            color='primary'
            variant='contained'
          >
            Continue
          </Button>
        </DialogActions>
      </DialogStyled>

      <OpenSubmissionsModal
        open={openSubmissionsModal}
        onClose={() => {
          setOpenSubmissionsModal(false);
          onRequestClose();
        }}
      />
    </>
  );
};

export default MigrateToM1;
